// extracted by mini-css-extract-plugin
export default {"pingce":"index_pingce_XIxjf"};